// extracted by mini-css-extract-plugin
export default {"video-link":"f_m d-flex align-items-center my-2","video-link__link":"f_n ml-2"};